import { SELECT_ALL_TYPE } from "../../components/tables/uiSelectAll/selectAllComponent.directive";
import { MT94XService } from "./txt/MT94XService";
import { CAMT05XService } from "./xml/CAMT05XService";
import { PDFService } from "./pdf/PDFService";
import { CSVService } from "./csv/CSVService";
import { VALUES } from "../arsweb/RoutingPaths";

/** @ngInject */
export class ReportService {

        constructor(controller, ArsConfig, userService) {
        this.controller = controller;
        const csvService = new CSVService(ArsConfig, userService);
        this.fileServices = {
            downloadMT94X : new MT94XService(ArsConfig, userService),
            downloadCAMT05X : new CAMT05XService(ArsConfig, userService),
            downloadPDF   : new PDFService(ArsConfig, userService),
            downloadCSV   : csvService,
            downloadZIP_Xls   : csvService,
            downloadZIP  : csvService,
            downloadXls   : csvService
        };
    }

    exportFile(params, downloadFunction) {
        this.fileServices[downloadFunction][downloadFunction](this.controller, this.getSelection(), params);
    }

    getSelection() {
        return (!this.controller.checkboxes || this.controller.checkboxes.selectType === SELECT_ALL_TYPE.GLOBAL) ? null : this.controller.getSelectedRowIDs();
    }

    exportFileForReact(params, downloadFunction) {
        this.controller.backendService.service.config.params.sort = this.controller.getSort();
        const selIds = (this.controller.restUrl === VALUES) ?
            this.controller.gridApi.getSelectedNodes().map(node => node.data.key) : this.controller.getSelectedRowIDs();
        this.fileServices[downloadFunction][downloadFunction](
            this.controller, this.controller.isAllSelected ? null : selIds, params);
    }
}
